/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 日志打印方法
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-10-10 14:54:09
 * @LastEditTime: 2023-10-10 14:48:14
 * @FilePath: /client-h5-v2/src/common-ts/printlog.ts
 */
import { apiPrintLog, apiPrintLogWebview } from '@/apis/pringlog/printlog'
import store from '@/store/index'
import { getCookie, getUUID } from './utils'

// 打印日志参数封装
const printParams = () => {
  return {
    // 用户信息
    userInfo: store.getters['global/userInfo'],
    // 事件信息
    event: {
      eventId: getUUID(),
      eventName: '通用交互事件/通用曝光事件',
      eventType: '通用交互事件类型/通用曝光事件类型',
      payload: {
        senario: {
          scenarioCode: store.getters['global/scenarioCode'] || '',
          scenarioName: store.getters['global/scenarioName']
        },
        action: '点击/曝光',
        item: {
        },
        template: {
        }
      },
      relatedId: {
        userId: getCookie('userId') || localStorage.getItem('userId') || store.getters['session/userId'] || '',
        serviceId: store.getters['session/serviceId'],
        threadId: '',
        turnId: store.getters['session/turnId']
      }
    },
    // 拦截器用于判断是否进行接口加解密
    isEncrypt: true
  }
}

/**
 * @description: 日志请求方法
 * @return {*}
 */
// eslint-disable-next-line no-undef
const printlogRequest = (printData: LogDataParam) => {
  // console.log(JSON.stringify(printData.event.payload))
  if (process.env.NODE_ENV === 'development') {
    return false
  }
  // 创建webview渠道列表
  const webviewChannelList = ['facebook', 'whatsapp', 'wechat', 'line']
  // 判断是否是webview渠道
  if (webviewChannelList.includes(store.getters['global/channel'].toLowerCase())) {
    apiPrintLogWebview(printData)
  } else {
    apiPrintLog(printData)
  }
}

/**
 * @description: 点击事件打印日志
 * @param {*} logData
 * @return {*} void
 */
// eslint-disable-next-line no-undef
export const printClickLog = (logData: printLogParams, relatedId: RelatedId) => {
  const printData = printParams()
  printData.event.eventName = 'front_user_interaction'
  printData.event.eventType = 'customize'
  printData.event.payload['action'] = 'click'
  printData.event.payload['item'] = logData.item
  printData.event.payload['template'] = logData.template
  printData.event.relatedId['serviceId'] = relatedId.serviceId || ''
  printData.event.relatedId['turnId'] = relatedId.turnId || ''
  printlogRequest(printData)
}

/**
 * @description: 曝光事件打印日志
 * @param {*} logData
 * @return {*} void
 */
// eslint-disable-next-line no-undef
export const printExposureLog = (logData: printLogParams, relatedId: RelatedId) => {
  const printData = printParams()
  printData.event.eventName = 'template_exposure'
  printData.event.eventType = 'customize'
  printData.event.payload['action'] = 'exposure'
  printData.event.payload['item'] = {}
  printData.event.payload['template'] = logData.template
  printData.event.relatedId['serviceId'] = relatedId.serviceId || ''
  printData.event.relatedId['turnId'] = relatedId.turnId || ''
  printlogRequest(printData)
}

